import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { CreditService } from 'src/app/services/subscription/credit.service';
import { PopupService } from 'src/app/services/general/popup.service';

import { AccountsSetupComponent } from 'src/app/components/accounts/accounts-setup/accounts-setup.component';
import { AccountShareComponent } from 'src/app/components/account/account-share/account-share.component';

import { Credit } from 'src/app/interfaces/credit';

@Component({
  selector: 'app-user-redeem-credit',
  templateUrl: './user-redeem-credit.component.html',
  styleUrls: ['./user-redeem-credit.component.scss'],
})
export class UserRedeemCreditComponent implements OnInit, OnDestroy {

  /**
   * Credit id
   */
  @Input() private creditId: string;
  /**
   * Page mode
   */
  @Input() pageMode: boolean;

  disableSetupLaterBtn: boolean;

  /**
   * Constructor
   * @param router router
   * @param fns angularfire functions
   * @param modalController modal controller
   * @param translate translate service
   * @param creditService credit service
   * @param updateByService update by service
   * @param popupService popup service
   */
  constructor(
    private router: Router,
    private modalController: ModalController,
    private translate: TranslateService,
    private creditService: CreditService,
    private popupService: PopupService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  /**
   * Before view enter
   */
  ionViewWillEnter() {
    const credit = this.creditService.getCreditById(this.creditId);
    if (!credit?.creditId || credit.redeemed) {
      this.promptError();
    }
  }

  /**
   * Prompt error
   */
  async promptError() {
    const modal = await this.popupService.presentAlert(this.translate.instant('CREDIT.msg.invalid_id'));
    modal.onDidDismiss().then(() => {
      if (!this.pageMode) {
        this.dismissModal();
      }
    });
  }

  /**
   * Dismiss Avatar Modal
   * @param avatar Avatar
   */
  async dismissModal() {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) {
        modal.dismiss();
      }
    }
  }

  /**
   * Present account setup modal
   */
  async presentAccountSetupModal() {
    if (this.creditId) {
      const modal = await this.modalController.create({
        component: AccountsSetupComponent,
        componentProps: {
          premium: true,
          creditId: this.creditId
        }
      });
      modal.present();
      modal.onDidDismiss().then((result: any) => {
        if (!this.pageMode && result?.data?.dismiss) {
          setTimeout(() => {
            this.dismissModal();
          }, 10);
        }
      });
    } else {
      this.popupService.presentActionError();
    }
  }

  /**
   * Present account share modal
   * @param credit credit
   */
  async presentAccountShareModal(credit: Credit) {
    if (credit) {
      const modal = await this.modalController.create({
        component: AccountShareComponent,
        cssClass: 'modal-full-screen-bk',
        componentProps: {
          credit,
          giftCard: true
        }
      });
      modal.present();
    } else {
      this.popupService.presentActionError();
    }
  }

  /**
   * Send as gift
   */
  async sendAsGift() {
    this.creditService.sendAsGift(this.creditId);
  }

  /**
   * Setup later
   */
  setupLater() {
    if (this.pageMode) {
      this.goUserCreditPage();
    } else {
      this.dismissModal();
    }
  }

  /**
   * Go user credit page
   */
  goUserCreditPage() {
    this.router.navigate(['/user/credit']);
  }
}
